import { createApiCaller, createApiClient } from "./client";
import { BASE_URL_ADMIN } from "../constants";

const client = createApiClient(`${BASE_URL_ADMIN}/admin`);

export default createApiCaller(client);
